import {SplitText} from 'gsap/SplitText.js';

document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(SplitText);

    //only apply animation for xlarge and bigger
    if (document.body.clientWidth >= 1024) {
        //Animate buttons
        let jsButton = Array.prototype.slice.call(document.querySelectorAll('.button--primary:not(.no-animation), .button--secondary:not(.no-animation)'));

        jsButton.forEach(function (self) {
            gsap.to(self.querySelector('.button-bg'), {immediateRender: false, scrollTrigger: self, opacity: 1, duration: 1, delay: 0.2});
            gsap.to(self.querySelector('.button-bg'), {immediateRender: false, scrollTrigger: self, width: '100%', duration: 0.6, delay: 0.8});
            gsap.to(self.querySelector('.button-text'), {immediateRender: false, scrollTrigger: self, opacity: 1, duration: 0.5, delay: 1.3});
            gsap.to(self.querySelector('.button-arrow'), {immediateRender: false, scrollTrigger: self, opacity: 1, duration: 0.5, delay: 1.3});
        });

        //Animate images picture
        let jsMedia = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animate-media picture'));

        jsMedia.forEach(function (self) {
            gsap.to(self, {scrollTrigger: self, maskSize: '100% 100%', ease: 'Power2.inOut', duration: 0.2, delay: 0.2});
        });

        //Animate images figure
        let jsMediaFigure = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animate-media figure'));

        jsMediaFigure.forEach(function (self) {
            gsap.to(self, {scrollTrigger: self, maskSize: '100% 100%', ease: 'Power2.inOut', duration: 0.2, delay: 0.2});
        });

        //animated lines
        let jsLine = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animated-lines'));

        jsLine.forEach(function (self) {
            gsap.to(self.querySelectorAll('.animated-line'), {scrollTrigger: self, delay: 0.7, width: '100%', duration: 1.2});
        });
    }

    //Animate play button
    let jsPlayButton = Array.prototype.slice.call(document.querySelectorAll('.play-button'));

    jsPlayButton.forEach(function (self) {
        gsap.to(self.querySelector('.icon'), {immediateRender: false, scrollTrigger: self, scale: 1, duration: 0.2, delay: 1});
        gsap.to(self.querySelector('.icon-text'), {immediateRender: false, scrollTrigger: self, y: 0, opacity: 1, duration: 0.5, delay: 1.3});
    });

    //Instagram button
    let jsInstagram = Array.prototype.slice.call(document.querySelectorAll('.instagram-button'));

    jsInstagram.forEach(function (self) {
        gsap.to(self.querySelector('.icon'), {immediateRender: false, scrollTrigger: self, scale: 1, duration: 0.2, delay: 1});
        gsap.to(self.querySelector('.icon-text'), {immediateRender: false, scrollTrigger: self, y: 0, opacity: 1, duration: 0.5, delay: 1.3});
    });

    //Animate text
    let jsParagraph = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animate-text p'));

    jsParagraph.forEach(function (self) {
        gsap.to(self, {scrollTrigger: self, opacity: 1, y: 0, duration: 1, delay: 0.2});
    });

    //Animate list
    let jsList = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animated-list ul'));

    jsList.forEach(function (self) {
        gsap.to(self, {scrollTrigger: self, opacity: 1, y: 0, duration: 1, delay: 0.2});
    });

    //Animate list ol
    let jsListOl = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animated-list ol'));

    jsListOl.forEach(function (self) {
        gsap.to(self, {scrollTrigger: self, opacity: 1, y: 0, duration: 1, delay: 0.2});
    });

    //Animate glow
    let jsGlow = Array.prototype.slice.call(document.querySelectorAll('section .section-glow'));

    jsGlow.forEach(function (self) {
        gsap.to(self, {scrollTrigger: self, y: 200, duration: 3, delay: 1.5});
    });

    //Animate titles
    let jsTitles = Array.prototype.slice.call(document.querySelectorAll('section.has_animation .animate-title'));
    jsTitles.forEach(function (self) {
        gsap.to(self, {scrollTrigger: self, autoAlpha: 1});

        let split = new SplitText(self.querySelector('.title'), {scrollTrigger: self, charsClass: 'chars', linesClass: 'lines', tag: 'span'});

        gsap.from(split.chars, 1, {
            duration: 0.2,
            y: 20,
            autoAlpha: 0,
            ease: 'power3.out',
            stagger: 0.03,
            delay: '>-75%',
            scrollTrigger: {
                trigger: self
            }
        });
    });
});

//content-scroll must be the first one
document.addEventListener('DOMContentLoaded', function () {
    let sectionContentScroll = Array.prototype.slice.call(document.querySelectorAll('section.block_content_scroll'));

    sectionContentScroll.forEach(function (self) {
        let trigger = self.querySelector('.panel.first');
        let panels = self.querySelectorAll('.panel');
        let outer = self.querySelector('.outer');
        let wrapper = self.querySelector('.wrapper');
        let progressbar = self.querySelector('progress');
        let wrapperHeight = 0;
        let extraPadding = 40;
        let progressBarTop = 16;

        if (document.body.clientWidth >= 1024) {
            extraPadding = 80;
            progressBarTop = 48;
        }

        //calculate highest panel
        panels.forEach(function (panel) {
            let currentWrapperHeight = panel.offsetHeight;

            if (currentWrapperHeight >= wrapperHeight) {
                wrapperHeight = currentWrapperHeight;
            }
        });

        //make all panels even high
        panels.forEach(function (panel) {
            panel.style.height = wrapperHeight + 'px';
        });

        //make wrapper as heigh as panel + extra padding
        wrapperHeight = wrapperHeight + extraPadding;
        wrapper.style.height = wrapperHeight + 'px';
        progressbar.style.width = (wrapperHeight - progressBarTop) + 'px';

        let tl = gsap
            .timeline({
                scrollTrigger: {
                    trigger: trigger,
                    pin: self,
                    start: 'bottom bottom-=' + 80,
                    end: '+=' + wrapperHeight * (panels.length - 1),
                    scrub: true
                }
            })
            .eventCallback('onComplete', function () {
                ScrollTrigger.refresh();
                scrollTriggerRefresh();
            })
            .to(outer, {
                y: () => -wrapperHeight * (panels.length - 1)
            });

        gsap.to(progressbar, {
            value: 100,
            scrollTrigger: {
                trigger: trigger,
                start: 'bottom bottom-=' + 80,
                end: '+=' + (wrapperHeight * (panels.length - 1)),
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    });
});

//block-netflix must be the second one
document.addEventListener('DOMContentLoaded', function () {
    const netflixSlider = document.querySelectorAll('.block_netflix');

    netflixSlider.forEach((slider) => {
        const container = slider.querySelector('.slides');
        const panels = gsap.utils.toArray('.panel', slider);
        const progressbar = slider.querySelector('progress');
        let panelsTotal = panels.length;

        //Count total panels and set max to 4
        if (panelsTotal >= 4) {
            panelsTotal = 4;
        }

        //Decide the flex-basis of each panel
        let panelWidth = 'calc(100% / ' + panelsTotal + ' - 16px)';
        if (document.body.clientWidth <= 1024 && panelsTotal > 2) {
            panelWidth = 'calc(40% - 16px)';
        }
        if (document.body.clientWidth <= 768 && panelsTotal > 2) {
            panelWidth = 'calc(48% - 16px)';
        }
        if (document.body.clientWidth <= 640) {
            panelWidth = 'calc(48% - 16px)'
        }
        if (document.body.clientWidth <= 550) {
            panelWidth = 'calc(75% - 16px)'
        }

        //Set flex basis on panels
        gsap.set(panels, {flexBasis: panelWidth});

        //Create timeline for all slides
        const tlPanels = gsap.to(panels, {
            x: () => container.clientWidth - container.scrollWidth,
            ease: 'none',
            scrollTrigger: {
                trigger: slider,
                start: 'bottom bottom',
                end: () => `+=${container.scrollWidth - container.clientWidth}`,
                onUpdate: (self) => {
                    const progress = self.progress;
                    const activeIndex = Math.round((panels.length - 1) * progress);
                    const activeSlide = slider.querySelectorAll('.panel')[activeIndex];
                    slider.querySelectorAll('.panel').forEach((slide) => {
                        slide.classList.remove('active');
                        if (slide.querySelector('video')) {
                            slide.querySelector('video').pause();
                        }
                    });
                    if (activeSlide) {
                        activeSlide.classList.add('active')
                        if (activeSlide.querySelector('video')) {
                            activeSlide.querySelector('video').play();
                        }
                    }
                },
                pin: true,
                scrub: true,
                snap: {
                    snapTo: 1 / (panels.length - 1),
                    duration: 0.2,
                    delay: 0.2,
                    ease: 'easeIn'
                },
                invalidateOnRefresh: true
            }
        });

        //Hide progress bar when slider total width is not larger than grid width
        if (container.scrollWidth > container.getBoundingClientRect().width) {
            progressbar.style.display = 'block';
        }

        panels.forEach((panel, index) => {
            const panelVideo = panel.querySelector('video');
            const panelPlayButton = panel.querySelector('.play-button');
            const panelPlayButtonText = panel.querySelector('.play-button .icon-text');
            const prevButton = panel.querySelector('.prev');
            const nextButton = panel.querySelector('.next');
            const overlayContent = panel.querySelector('.small .content');
            const overlayButton = panel.querySelector('.small .button').offsetHeight + 33;

            if (document.body.clientWidth >= 1024) {
                overlayContent.style.transform = 'translateY(' + overlayButton + 'px)';
            }

            if (panelVideo && panelPlayButton) {
                panelPlayButton.addEventListener('click', () => {
                    if (panelVideo.muted === true) {
                        panelVideo.muted = false;
                        panelPlayButtonText.innerText = panelPlayButtonText.getAttribute('data-unmuted');
                    } else {
                        panelVideo.muted = true;
                        panelPlayButtonText.innerText = panelPlayButtonText.getAttribute('data-muted');
                    }
                });
            }

            //Function to slide to correct panel with prev/next buttons
            function slideToPanel(slide) {
                const offset = panel.getBoundingClientRect().width * slide;
                gsap.to(window, {
                    scrollTo: {
                        y: offset + tlPanels.scrollTrigger.start,
                        autoKill: false
                    },
                    duration: 0.2,
                    delay: 0
                });
            }

            //Click to next panel
            nextButton.addEventListener('click', () => {
                slideToPanel(index + 1);
            });

            //Click to previous panel
            prevButton.addEventListener('click', () => {
                slideToPanel(index);
            });

            panel.querySelector('.small').addEventListener('click', () => {
                //Add exploded class to main section
                slider.classList.add('exploded');

                //Create timeline per panel
                const tl = gsap.timeline({
                    onComplete: () => {
                        ScrollTrigger.refresh();
                        scrollTriggerRefresh();
                    }
                })
                    .to(panels, {
                        flexBasis: '0',
                        duration: 0.4
                    })
                    .to(panel, {
                        flexBasis: 'calc(100% - 16px)',
                        duration: 0.4
                    }, '-=0.4')
                    .addPause(0.6)
                    .to(panels, {
                        flexBasis: 'calc(100% - 16px)',
                        duration: 0
                    })

                //Wait for panel width animation and slide to correct offset
                gsap.delayedCall(0.6, () => {
                    const offset = panel.getBoundingClientRect().width * index;
                    gsap.to(window, {
                        scrollTo: {
                            y: offset + tlPanels.scrollTrigger.start,
                            autoKill: false
                        },
                        duration: 0,
                        delay: 0
                    });

                    progressbar.style.display = 'block';
                });
            });

            panel.querySelector('.js-close-panel').addEventListener('click', () => {
                //Remove exploded class from main section
                slider.classList.remove('exploded');

                gsap.timeline({
                    onComplete: () => {
                        ScrollTrigger.refresh();
                        scrollTriggerRefresh();
                    }
                })
                    .to(panels, {
                        flexBasis: panelWidth,
                        duration: 0
                    });

                //Go back to start of the main ScrollTrigger
                gsap.to(window, {
                    scrollTo: {
                        y: tlPanels.scrollTrigger.start,
                        autoKill: false
                    },
                    duration: 0,
                    delay: 0
                });
            });
        });

        gsap.to(progressbar, {
            value: 100,
            ease: 'none',
            scrollTrigger: {
                trigger: slider,
                start: 'bottom bottom+=20',
                end: () => `+=${container.scrollWidth - container.clientWidth}`,
                scrub: 0.3,
                invalidateOnRefresh: true
            }
        });
    });
});

//block-carousel must be the last one
document.addEventListener('DOMContentLoaded', function () {
    let section = Array.prototype.slice.call(document.querySelectorAll('.block_carousel'));

    section.forEach(function (self) {
        let trigger = self.querySelector('.gallery');
        let pin = self.querySelector('.left');
        let links = gsap.utils.toArray(self.querySelectorAll('.indicators .indicator-item'));
        let titles = gsap.utils.toArray(self.querySelectorAll('.heading-h3.js-title'));

        gsap.set(self.querySelectorAll('.image:not(:first-child)'), {opacity: 0})

        gsap
            .timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top top',
                    end: 'bottom bottom',
                    pin: pin,
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            })
            .to(self.querySelectorAll('.image:not(:first-child)'), {opacity: 1, duration: 1, stagger: 1})
            .eventCallback('onComplete', function () {
                ScrollTrigger.refresh();
                scrollTriggerRefresh();
            });

        function getSamePageAnchor(link) {
            return link.hash;
        }

        // Scroll to a given hash, preventing the event given if there is one
        function scrollToHash(hash, e) {
            const elem = hash ? document.querySelector(hash) : false;
            if (elem) {
                e.preventDefault();
                gsap.to(window, {scrollTo: elem});
                scrollTriggerRefresh();
            }
        }

        function setActive(link) {
            links.forEach(el => el.classList.remove('active'));
            link.classList.add('active');

            let activeTitle = link.getAttribute('href');
            activeTitle = document.querySelector(activeTitle + ' .js-title');

            titles.forEach(el => el.classList.add('heading-outline'));
            activeTitle.classList.remove('heading-outline');
        }

        self.querySelectorAll('.indicators .indicator-item').forEach(a => {
            let navigation = a.getAttribute('href');

            ScrollTrigger.create({
                trigger: navigation,
                start: 'top center',
                end: 'bottom center',
                onToggle: self => self.isActive && setActive(a)
            });

            a.addEventListener('click', e => {
                scrollToHash(getSamePageAnchor(a), e);
            });
        });
    });
});

function scrollTriggerRefresh() {
    ScrollTrigger.sort();
    ScrollTrigger.refresh();
}
